(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ReportXlsService', ReportXlsService);

    ReportXlsService.$inject = ['$http', '$mdDialog', '$translate', 'DateUtils', 'PlagiatValidationService'];

    function ReportXlsService($http, $mdDialog, $translate, DateUtils, PlagiatValidationService) {
        var service = {
            generateExcelFile: generateExcelFile
        };

        function generateExcelFile(obj, url, fileName) {
            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("global.report.xls.exporting-in-progress"))
                .ok("OK");
            $mdDialog.show(alert);

            $http({
                url: url,
                method: "POST",
                data: obj,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, fileName + DateUtils.getDateTimeForFileName(new Date()) + '.xlsx');
                return 'OK';
            }, function (error) {
                $mdDialog.hide();
                PlagiatValidationService.getModalError(error);
                return $q.reject(error);
            });
        }

        return service;
    }

})();
